import { Component, Input} from '@angular/core';
import { ParamData } from '../../models/param-data';

@Component({
    selector: 'display-param-text-data',
    styleUrls: ['./display-param-text-data.scss'],
    template: `
        <div class='border-bottom mb-1 p-1'>
            <div class='display-param-text-name'>
                <p class='m-0'>{{paramData.name}}</p>
            </div>
            <div class='display-param-text-data'>
                {{paramData.data}}
            </div>
        </div>
`
})
export class DisplayParamTextDataComponent {
    @Input() paramData: ParamData;
}
